export default __webpack_public_path__ + "static/21-d5c05985bdc85c8323b003d2f3ed7750.jpg";